import { render, staticRenderFns } from "./CustomCollapse.vue?vue&type=template&id=5befa3bc"
import script from "./CustomCollapse.vue?vue&type=script&lang=js"
export * from "./CustomCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5befa3bc')) {
      api.createRecord('5befa3bc', component.options)
    } else {
      api.reload('5befa3bc', component.options)
    }
    module.hot.accept("./CustomCollapse.vue?vue&type=template&id=5befa3bc", function () {
      api.rerender('5befa3bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/CustomCollapse.vue"
export default component.exports